import { AT_MOST_8_CHAR, IS_REQUIRED, MUST_GREATER_EQUAL_0_LESS_EQUAL_1 } from 'src/constants/errorMessages';
import { validateMaxLength, validateNumberRange, validateRequired } from 'src/util/validationsUtil';

import { DEFAULT_EMPTY_TERRITORY } from './TerritoryBasedGrid';

export const getCellValueErrorMsg = (value: string | undefined | number) => {
    if (typeof value === 'undefined') {
        return IS_REQUIRED;
    }
    if (typeof value === 'number') {
        value = value.toString();
    }
    if (!validateRequired(value)) {
        return IS_REQUIRED;
    }
    if (!validateNumberRange(value, 0, true, 1, true)) {
        return MUST_GREATER_EQUAL_0_LESS_EQUAL_1;
    }
    if (!validateMaxLength(value, 8)) {
        return AT_MOST_8_CHAR;
    }
    return '';
};

export const generateAggregateTableErrorMsg = (
    territory: string,
    errorMsg: string,
    territoryToRemove: string[],
    aggregatedErrMsg: string
) => {
    const errorMsgList: string[] = aggregatedErrMsg === '' ? [] : aggregatedErrMsg.split('; ');
    const newErrorMsgList: string[] = [];
    let territoryExist = false;
    errorMsgList.forEach((msg) => {
        const territoryInMsg = msg.substring(0, 2);
        if (!territoryToRemove.includes(territoryInMsg)) {
            if (territoryInMsg === territory) {
                territoryExist = true;
                if (errorMsg !== '') {
                    newErrorMsgList.push(territory + ':' + errorMsg);
                }
            } else {
                newErrorMsgList.push(msg);
            }
        }
    });
    if (!territoryExist && errorMsg !== '') {
        if (territory !== DEFAULT_EMPTY_TERRITORY) {
            newErrorMsgList.push(territory + ':' + errorMsg);
        } else {
            newErrorMsgList.push(territory + errorMsg);
        }
    }
    return newErrorMsgList.join('; ');
};
